import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-weather-map",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("../locations-common/settings"),
  presets: [
    {
      label: "bcm:widgets.weather-map.name",
      description: "bcm:widgets.weather-map.description",
      imageLink: require("./screenshot.png"),
      layout: [8, 8],
      widget: {
        config: {},
      },
    },
  ],
});
